import React from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { bulletinMentionOtherSpanSx, bulletinMentionSelfSpanSx } from '../constants/bulletinMentionUi';
import { parseBulletinBodySegments, stripBulletinFormatMarkers } from '../utils/bulletinBodySegments';

type Props = {
  /** 一覧 API の body_preview（本文トークン形式） */
  body: string;
  /** ログイン職員 ID（自分宛メンションの色分け） */
  myStaffId?: number;
};

/**
 * 掲示板一覧の本文プレビュー: 太字・色タグは除去し、メンションのみ詳細画面と同様に装飾する
 */
const BulletinPreviewBody: React.FC<Props> = ({ body, myStaffId }) => {
  const theme = useTheme();
  const segments = parseBulletinBodySegments(body);
  return (
    <>
      {segments.map((seg, i) =>
        seg.type === 'text' ? (
          <React.Fragment key={i}>{stripBulletinFormatMarkers(seg.text)}</React.Fragment>
        ) : (
          <Box
            component="span"
            key={i}
            sx={
              myStaffId !== undefined && seg.staffId === myStaffId
                ? bulletinMentionSelfSpanSx()
                : bulletinMentionOtherSpanSx(theme)
            }
          >
            @{seg.displayName}
          </Box>
        )
      )}
    </>
  );
};

export default BulletinPreviewBody;
